import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCalendarFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <g fill="#5F687A" clipPath="url(#CalendarFilled_svg__a)">
      <path d="M6.103 7.969a.76.76 0 0 0 .752-.753V5.742h4.825a.76.76 0 0 0 .753-.753.76.76 0 0 0-.753-.752H6.855V2.752A.76.76 0 0 0 6.103 2a.76.76 0 0 0-.753.752v4.464c0 .412.342.753.753.753" />
      <path d="M17.458 4.779a1.87 1.87 0 0 0-1.324-.552H14.66V2.752A.76.76 0 0 0 13.907 2a.76.76 0 0 0-.752.752v4.454c0 .412.34.753.752.753a.76.76 0 0 0 .753-.753V5.732h1.474c.1 0 .19.04.261.11.07.07.11.16.11.26v2.589h-13V6.103c0-.1.04-.19.11-.261.07-.07.16-.11.26-.11a.76.76 0 0 0 .753-.753.76.76 0 0 0-.752-.752A1.885 1.885 0 0 0 2 6.103v10.031a1.885 1.885 0 0 0 1.876 1.876h12.268a1.885 1.885 0 0 0 1.876-1.876V6.093c0-.492-.2-.973-.552-1.324zm-.963 11.355c0 .1-.04.19-.11.261-.07.07-.16.11-.26.11H3.864c-.1 0-.19-.04-.26-.11a.36.36 0 0 1-.11-.26v-5.94h12.99v5.94z" />
      <path d="M5.25 12.814h9.49c.28 0 .501-.221.501-.502 0-.28-.22-.502-.501-.502H5.25c-.28 0-.501.221-.501.502s.22.502.501.502M13.406 13.887H6.604c-.28 0-.501.22-.501.502 0 .28.22.501.501.501h6.802c.28 0 .501-.22.501-.501s-.22-.502-.501-.502" />
    </g>
    <defs>
      <clipPath id="CalendarFilled_svg__a">
        <path fill="#fff" d="M2 2h16v16H2z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgCalendarFilled;
